import { render, staticRenderFns } from "./jobStatistics.vue?vue&type=template&id=257b3264&scoped=true"
import script from "./jobStatistics.vue?vue&type=script&lang=js"
export * from "./jobStatistics.vue?vue&type=script&lang=js"
import style0 from "./jobStatistics.vue?vue&type=style&index=0&id=257b3264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257b3264",
  null
  
)

export default component.exports